<div class="shared-case-page jsPanel-content">
    <card-detail-popup *ngIf="cardDetail" [cardDetail]="cardDetail" [hideShare]="true" [sharePage]="true" pageName="SHARED"></card-detail-popup>
</div>
